import React from "react";

const LoginPage = React.lazy(async () => import("./pages/login-page"));

export const LoginRoutes = LoginPage;
